export default __webpack_public_path__ + "static/russian-946cecc395d5948c08a53fa049fc2c9b.jpg";